import { BTN_BASE, BTN_SHADOW } from '@/components/Form/Button/legacyButtonClasses'
import GSwal from '@/components/GSwal'
import type { IProductCard } from '@/schemas/catalog/product'

/** Produto mostrado no alerta: só nome e imagem. */
type IAlertProduct = Pick<IProductCard, 'name' | 'thumbnailUrl'>

/**
 * Alerta de produto adicionado ao carrinho (com a foto e o nome), com "Ver carrinho" e "Continuar comprando". Usado pelo
 * card de produto.
 */
export const showProductAlert = (
    title: string,
    icon: 'success' | 'info' | 'warning' | 'question' | 'error' = 'success',
    productData?: IAlertProduct,
    confirmUrl: string = '/carrinho',
) => {
    GSwal.fire({
        icon: icon,
        title: `${title}`,
        html: `
      <div class='flex flex-row items-center gap-2 ${!productData && 'hidden'}'>
        <img
        title="${productData?.name}"
        src="${productData?.thumbnailUrl}"
        alt="${productData?.name}"
        width="100"
        height="100"
        class="rounded-xl"
        />
        <p class='text-sm text-left'>${productData?.name}</p>
      </div>
    `,
        showCancelButton: true,
        confirmButtonText: `<a href="${confirmUrl}" class="${BTN_BASE} h-12 text-sm leading-[1em] font-[600] text-white max-md:min-w-full w-full rounded-full pt-1 pb-1 px-8! max-h-[2.6rem]! min-h-8! border-none border-transparent bg-transparent outline-current outline-hidden ring-0 hover:bg-base-content/20">Ver carrinho</a>`,
        cancelButtonText: 'Continuar comprando',
        buttonsStyling: false,
        customClass: {
            title: 'text-destaques text-xl p-2 mt-2',
            confirmButton: 'rounded-full max-md:w-full text-[14px] border-none bg-secondary text-white p-0',
            cancelButton: `${BTN_BASE} ${BTN_SHADOW} h-12 leading-[1em] font-[600] max-md:w-full rounded-full text-[14px] border-none border-base-200 outline-base-content pt-1 pb-1 max-h-[2.6rem]! min-h-8! bg-tertiary-green text-white px-5 pt-2 pb-2 hover:bg-[color-mix(in_oklab,var(--color-base-200)_90%,#000)]`,
            popup: 'rounded-3xl min-w-[600px] max-md:min-w-full',
            actions:
                'w-full max-md:w-10/12 mx-auto flex flex-row max-md:flex-row max-md:justify-between gap-3 justify-center items-center mb-4',
        },
    })
}
